import React, { Component } from 'react';
import { withStyles } from '@mui/styles';
import Nav from './Nav';
import { connect } from 'react-redux';

const styles = theme => {

  return {
    container: {
      backgroundColor: theme.palette.grey[800],
    },
  };
};

class Header extends Component {

  componentDidMount() {
    this.loadImage();
  };

  componentDidUpdate(prevProps) {
    if (prevProps.booking !== this.props.booking) {
      this.loadImage();
    }
  };

  loadImage = () => {
    if (!this.props.booking) {
      return;
    }
    /*
    this.props.getImage(this.props.booking.id).then(image => {
      if (image.content) {
        const styleWithImage = {
          backgroundImage: `url("data:image/gif;base64,${image.content}")`,
        };

        this.setState({ styleWithImage });
      }

    });*/
  };

  render() {
    //TODO inject some parts of the booking into template
    const {
      classes,
    } = this.props;

    return (
      <div className={classes.container} >
        <Nav />
      </div>
    );
  }
}

const mapStateToProps = state => ({ booking: state.api.booking });

export default connect(mapStateToProps)(withStyles(styles)(Header));
